import _ from 'lodash';
import { memo } from 'react';
import { NextPage } from 'next';
import styled from '@emotion/styled';
import WidgetSocial from './widget-social-share';
import { NextRouter, useRouter } from 'next/router';
import { DATALAYER_TYPE } from 'src/utils/datalayer/send-datalayer';
import useResponsive from 'src/utils/devices';
import { useDatePublished } from 'src/utils/helper';
import { Viewer } from '../cards';
import { DEFAULT_COUNT_VIEW } from 'src/constants';
import { BsCalendar2Check } from 'react-icons/bs';

type Props = {
  data: any;
  showWidgetSocial?: boolean;
  showDate?: boolean;
  showViewer?: boolean;
  showGallery?: boolean;
  countView?: any;
  showPart?: boolean;
  setVideoPart?: any;
};
const WidgetMetaContent: NextPage<Props> = ({ data, showWidgetSocial = true, showDate = true, showViewer = false, showGallery = true, countView, showPart = false, setVideoPart }) => {

  const router: NextRouter = useRouter();
  const responsive = useResponsive();
  const conditionCountview: boolean = showViewer && countView > DEFAULT_COUNT_VIEW;

  return (
    <WidgetWrapper className='widget-meta-content'>
      <div className='meta'>
        <div className='meta-left'>
          {showDate && (data.published_at || data.dateDefault) && (
            <div className='date-publish'>
              <div className='date'>
                <BsCalendar2Check size={14} />
                {`${useDatePublished(data.published_at || data.dateDefault)}`}
              </div>
            </div>
          )}
          {conditionCountview && <Viewer data={countView} />}
          {
            (showPart && ((!_.isEmpty(data?.data)) && data?.data?.length > 1)) && (
              <div className='part-item'>
                {/* <span>PART</span> */}
                {
                  data.data?.map((item: any, index: any) => (
                    <a className='button-part' href={`/video-gallery/tv-program/${data.id}?part=${index + 1}`} onClick={() => { setVideoPart(index); }}>{index + 1}</a>
                  ))
                }
              </div>
            )
          }
        </div>
        {showWidgetSocial && (
          <WidgetSocial
            articleLink={`${router.asPath}`}
            // ! DATALAYER
            eventDataLayer={{
              type: DATALAYER_TYPE.TRACK_POSITION,
              router: router?.pathname,
              position: responsive.isMobile ? (showGallery ? 'ใต้:อัลบั้มรูป' : 'ใต้:รูปภาพปก') : 'ใต้:รูปภาพปก',
              section: 'แชร์'
            }}
          />
        )}
      </div>
    </WidgetWrapper>
  );
};
const WidgetWrapper = styled.div`
  font-family: var(--front-thin), sans-serif;
  position: relative;
  width: 100%;
  display: block;
  margin: 15px auto 0;
  @media (max-width: 690px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    svg {
      width: 12px;
      height: 12px;
    }
  }
  .meta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 10px;
    width: 100%;
    @media (max-width: 767px) {
      margin-top: 10px;
      padding-bottom: 0px;
    }
    .meta-left {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      justify-content: flex-start;
      gap: 10px;
      .--active{
        background-color: #212b62 !important;
      }
      .part-item{
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .button-part{
        cursor: pointer;
        color: #fff;
        font-size: 12px;
        margin: 4px;
        padding: 7px 10px;
        background-color: #4a5dbd;
        border: none;
        border-radius: 10%;
      }
    }
    .date-publish,
    .viewer {
      display: flex;
      font-weight: 300;
      color: #aaa;
      align-items: center;
    }
    .date-publish {
      svg {
        margin-right: 5px;
        margin-top: 5px;
      }
    }

    .date-publish,
    svg,
    .viewer span {
      font-size: 14px;
      margin-right: 5px;
      @media (max-width: 690px) {
        font-size: 12px;
      }
    }
  }

  @media (max-width: 767px) {
    .widget-social-share {
      .title {
        text-align: end;
        margin: 10px 5px 5px 0;
        padding: 0;
      }
      .list-items {
        display: flex;
        justify-content: space-between;
        align-items: center;
        svg {
          vertical-align: middle;
          height: 30px;
          width: 30px;
          color: #fff;
        }
      }
    }
  }
`;
export default memo(WidgetMetaContent);
